import {asyncScheduler, from, interval, of, Subject, timer} from "rxjs";
import {
    buffer,
    delay,
    delayWhen,
    map,
    mergeMap,
    take,
    tap,
    throttleTime,
    concatMap,
    concatAll,
    switchMap
} from "rxjs/operators";
import {not} from "rxjs/internal-compatibility";

export interface ObservedEvent {
    el: HTMLElement | Element;

    callback(e: any): void;

    index: number;
    inView?: boolean;

}

const animCallbackMapDefault: { [key: string]: (el: any) => void } = {

    showEl: el => jQuery(el).addClass('show'),

    delay: el => {
        setTimeout(() => jQuery(el).addClass('show'),
            jQuery(el).data('acbDelay') ? parseInt(jQuery(el).data('acbDelay')) : 500);
    },

    growingLogo: el => {

    }



    /* contactFlip: el => {


         let ss = ['<h1>NEED A HAND?</h1>'/!*, '<h1>HAVE A QUESTION?</h1>'*!/, '<h1>NEED MORE INFO?</h1>'];
         /!*let front = jQuery(el).find('.card-front');
         let back = jQuery(el).find('.card-back');*!/
         jQuery(el).addClass('show');

         let ct = jQuery('.anim-ct');
        /!* interval( 5000).pipe(
             map(e => [e % 2 == 0, ss[(e +1 ) % 3], (e+1) *180]),
             tap( ([makeFlipped, nextText, deg ]: [number, string, number]) => {
                // console.log('makeFlipped', makeFlipped, 'next', deg);
                 makeFlipped ? back.html(nextText) : front.html(nextText);
                 jQuery(el).css('transform', `rotateY(${deg}deg)`);
                     //jQuery(el).removeClass('is-flipped');

             })
         ).subscribe()*!/
         interval(3500).pipe(
             map(e => (e + 1 + ss.length) % ss.length),
             tap( e => ct.addClass('leave')),
             delay(260),
             tap( e => {
                 ct.html(ss[e]);
                 ct.removeClass('leave');
             })
         ).subscribe();
     }*/
    // paras:
};


export class IntersectionObserverController {

    el;
    index;
    rootEl;
    threshold;
    observer: IntersectionObserver;
    subject: Subject<ObservedEvent>;
    callback;
    killAfterObserve;

    constructor(elData: { el: HTMLElement | Element; index?: number },
                subject, callback = null, rootEl = null, threshold = 0.5, killAfterObserve = true) {
        this.el = elData.el;
        this.index = elData.index
        this.subject = subject;
        this.rootEl = rootEl;
        this.threshold = threshold;
        this.callback = callback;
        this.killAfterObserve = killAfterObserve;
        this.init();
    }

    init() {


        this.observer = new IntersectionObserver((data) => {
            // console.log(data, 'intersection observer');
            if (data[0].isIntersecting) {
                // console.log(data, 'DIRECTIVE - intersection observer is intersecting ');
                if (this.killAfterObserve) {
                    this.observer.unobserve(this.el);
                    this.observer.disconnect();
                }
                // this._observed = true;
                this.subject.next({el: this.el, callback: this.callback, index: this.index, inView: true});
            } else if (!this.killAfterObserve) {
                this.subject.next({el: this.el, callback: this.callback, index: this.index, inView: false})
            }
        }, {
            root: this.rootEl,
            threshold: this.threshold,
        });
        this.observer.observe(this.el);

    }

    static createSelectorsObservable(selectors, threshold = 0.1, animCallbackMap = {}, delayer = null, subject?: Subject<any>,
                                     defaultPause = 300) {
        if (!subject) {
            subject = new Subject<any>();
        }
        /*if(!animCallbackMap){
            animCallbackMap = animCallbackMapDefault;
        }*/
        animCallbackMap = {...animCallbackMap, ...animCallbackMapDefault};
        console.log(animCallbackMap);
        jQuery(selectors).map((index, el) =>
            new IntersectionObserverController(
                {el, index},
                subject,
                (el) => {
                    let $el = jQuery(el)
                    $el.data('acb') && animCallbackMap[$el.data('acb')] ?
                        animCallbackMap[$el.data('acb')](el) :
                        $el.addClass('show');
                    if ($el.data('acbMarkCompleted')) {
                        $el.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
                            // your event handler
                            $el.addClass('completed')
                        },);
                    }
                },
                null,
                jQuery(el).data('acbThreshold') || threshold
            ));
        return IntersectionObserverController.pipeSubject(subject, delayer, defaultPause)
    }

    static pipeSubject(subject, delayer: any[] = null, defaultPause) {
        const afterObs$ = subject.asObservable().pipe(
            throttleTime(100, asyncScheduler, {trailing: true})
        );

        const delayed = (arr) => {
            return from(arr).pipe(
                map((a: any) => interval(a.pause).pipe(
                    map(_ => a),
                    take(1)
                )),
                concatAll()
            );
        };
        return subject.pipe(
            // tap( e => console.log(e)),
            buffer(afterObs$),
            delayWhen(e => delayer && delayer.length > 0 ? interval(delayer[0].delay) : of(true)),
            /*scan( (acc, curr) => {
                 return {data: curr, index: acc.index +1}

            }, {index: -1}),*/
            /*map((e: any) => e.index % 200 == 0 ? e.data.sort( (a:any, b: any) => a.index < b.index ? -1 : 1)
                :e.data.sort( (a:any, b: any) => a.index < b.index ? 1 : -1)), */
            //tap(e => console.log('unsorted', e)),
            map((e: any) => e.sort((a: any, b: any) => a.index < b.index ? -1 : 1)),
            tap(e => console.log('after sorted', e)),
            map((e: any) => {

                return e.map(obj => jQuery(obj.el).data('acbPause') ? {
                    ...obj,
                    pause: jQuery(obj.el).data('acbPause')
                } : {
                    ...obj,
                    pause: defaultPause
                });
            }),
            tap(e => console.log('after pause data', e)),
            // map( e=> e.data),
            concatMap((els: any) => delayed(els)),


            /*delayWhen((el: any) => {
                console.log('for delay', el.pause);
                return interval(el.pause);
            }),*/
            tap((e: any) => e.callback(e.el, e.index))





            /* mergeMap ((els: any[]) => timer(0, 330).pipe(
                 take(els.length),
                 tap( (e:any)  => els[e].callback(els[e].el, els[e].index))
                 )
             )*/
            // tap (e => e.callback(els))
        )

    }

}